module.exports = __webpack_public_path__ + "static/media/vocabulary-easy-1000.11abbb92.png";